import { routes } from "router/routes"
import { SettingsCard } from "ui/SettingsCard"
import styles from "./ProSettings.module.css"

export const settingsMenuList = [
  {
    name: "Profile Information",
    id: "profile-information",
    iconName: "user",
    path: routes.proSettingsProfileInformation()
  },
  {
    name: "Profile Images",
    id: "profile-images",
    iconName: "userCircle",
    path: routes.proSettingsProfileImages()
  },
  {
    name: "Login & Security",
    id: "login-security",
    iconName: "password",
    path: routes.proSettingsLoginAndSecurity()
  },
  {
    name: "Mode Preferences",
    id: "mode-preferences",
    iconName: "brush",
    path: routes.proSettingsAdventureMode()
  },
  {
    name: "Payment Providers",
    id: "payment-providers",
    iconName: "card",
    path: routes.proSettingsPaymentProviders()
  },
  {
    name: "Social Networks",
    id: "social-networks",
    iconName: "link",
    path: "",
    comingSoon: true
  },
  {
    name: "Licenses",
    id: "licenses",
    iconName: "license",
    path: routes.proSettingsLicenses()
  },
  {
    name: "Billing",
    id: "billing",
    iconName: "investment",
    path: "",
    comingSoon: true
  },
  {
    name: "Google Calendar",
    id: "google-calendar",
    iconName: "calendar",
    path: routes.proSettingsGoogleCalendar()
  },
  {
    name: "Website Integration",
    id: "website-integration",
    iconName: "Code",
    path: routes.proSettingsWebsiteIntegration()
  },
  {
    name: "Account Management",
    id: "account-management",
    iconName: "settings",
    path: routes.proSettingsAccountManagement()
  }
]
export const ProSettings = () => {
  return (
    <div className={styles.wrapper}>
      {settingsMenuList.map((menu) => (
        <SettingsCard key={menu.id} title={menu.name} iconName={menu.iconName} path={menu.path} comingSoon={menu.comingSoon} />
      ))}
    </div>
  )
}
